import React, { useEffect } from 'react';
import { canIUse, Features } from '../helpers/PermissionUtility';
import OnboardingSurvey from './OnboardingSurvey';
import OnboardingSurveyV2 from './OnboardingSurveyV2';
import { useAuth } from '../context/AuthContext';
import { useAppSelector } from '../hooks/ReduxHooks';
import { useDispatch } from 'react-redux';
import { getProfile } from '../profile/actions';
import { Loader } from 'semantic-ui-react';

export default function OnboardingSurveyRouter() {
  const dispatch = useDispatch();
  const profileLoaded = useAppSelector<boolean>((state) => state.profile.loaded);
  const featuresLoaded = useAppSelector<boolean>((state) => !!state.profile?.features);
  const { isClientAuthenticated } = useAuth();

  useEffect(() => {
    if (isClientAuthenticated) {
      dispatch(getProfile());
    }
  }, [isClientAuthenticated]);

  if (!profileLoaded) {
    return <Loader />;
  }

  const useNewEntryExperience = canIUse(Features.EntryExperience24);
  if (useNewEntryExperience && featuresLoaded) {
    return <OnboardingSurveyV2 />;
  } else {
    return <OnboardingSurvey />;
  }
}
